export enum ROLES {
    ADMIN = 'admin',
    CONTRIBUTOR = 'write',
    MEMBER ='read',
}
